export default __webpack_public_path__ + "static/media/gray.c1fd5f3d.jpg";